import type { FieldValues, Path, UseFormReturn } from 'react-hook-form';

import { apiErrorMessage, fieldErrorMessage, isApiError } from '@/shared/api';

export interface FormLevelError {
  title: string;
  messages: string[];
  details?: Record<string, unknown>;
}

/**
 * Maps a 422 ApiError onto form fields. Returns what could not be mapped to a field,
 * for FormErrorSummary. Non-422 errors are returned unchanged as a form-level error.
 */
export function applyServerErrors<T extends FieldValues>(form: UseFormReturn<T>, error: unknown, knownPaths?: readonly string[]): FormLevelError | null {
  if (!isApiError(error)) return { title: apiErrorMessage(error), messages: [] };
  const unmapped: string[] = [];
  let focused = false;
  for (const fe of error.fieldErrors) {
    const path = fe.path as Path<T>;
    const known = knownPaths ? knownPaths.includes(fe.path) : true;
    if (known) {
      form.setError(path, { type: 'server', message: fieldErrorMessage(fe) }, { shouldFocus: !focused });
      focused = true;
    } else {
      unmapped.push(fieldErrorMessage(fe));
    }
  }
  if (error.fieldErrors.length && !unmapped.length && error.status === 422) return { title: apiErrorMessage(error), messages: [], details: error.details };
  return { title: apiErrorMessage(error), messages: unmapped, details: error.details };
}
